import React from "react";
import { Box } from "@mui/material";
import ButtonSquare from "../buttonSquare/ButtonSquare";
import { usePagination } from "../../utils/utils";

const Pagination = ({ totalItems, itemsPerPage, currentPage, setPage }) => {
  const pagesList = usePagination(totalItems, itemsPerPage, currentPage);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        justifyContent: "end",
      }}
    >
      <Box
        display="flex"
        gap="4px"
        justifyContent="center"
        sx={{ backgroundColor: "white" }}
        width={"fit-content"}
      >
        {currentPage > 1 && (
          <ButtonSquare
            onClick={() => {
              window.scrollTo(0, 0);
              setPage(currentPage - 1);
            }}
            action="Previous"
          />
        )}
        {pagesList.map((page, index) =>
          typeof page === "string" ? (
            <Box key={index}>...</Box>
          ) : (
            <ButtonSquare
              key={index}
              onClick={() => {
                window.scrollTo(0, 0);
                setPage(page);
              }}
              action={page === currentPage ? "number-active" : "number"}
              number={page}
            />
          )
        )}
        {currentPage < Math.ceil(totalItems / itemsPerPage) && (
          <ButtonSquare
            onClick={() => {
              window.scrollTo(0, 0);
              setPage(currentPage + 1);
            }}
            action="Next"
          />
        )}
      </Box>
    </Box>
  );
};

export default Pagination;
